import { connect } from 'react-redux';
import { disallow } from 'arts/actions/mail_subscriptions';
import SubscribePopupCounters from './subscribe_popup_counters';

const mapStateToProps = ({ mailSubscription }) => ({
  allowMailSubscription: mailSubscription.allow
});

export default connect(mapStateToProps, { disallow })(SubscribePopupCounters);
